import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { CoproducerVM } from "../models/coproducer-view.model";
import { Observable } from "rxjs/Observable";
import { FileUpload } from "../models/file-upload";
import { NameId } from "../models/nameId";
import { HttpClient } from "@angular/common/http";
import { CoproducerResponse } from "app/models/coproducer-response";

const URL = environment.apiBaseUrl;

@Injectable()
export class CoproducerService {
  constructor(private http: HttpClient) {}

  public coproducers(
    startRow: number,
    endRow: number,
    searchText: string,
    sortCol: string,
    sortDesc: boolean,
    showInactive: boolean
  ): Observable<CoproducerResponse> {
    const url =
      `${URL}CoProducerAgreements?startRow=${startRow}&endRow=${endRow}&searchString=${searchText}` +
      `&sortColumn=${sortCol}&sortDescending=${sortDesc}&showInactive=${showInactive}`;

    return this.http.get(url).map((x: any) => {
      const res = {
        coproducers: x.data as CoproducerVM[],
        total: x.total
      };
      return res;
    });
  }

  public getCoproducer(id: string): Observable<CoproducerVM> {
    return this.http.get<CoproducerVM>(`${URL}CoProducerAgreements/${id}`);
  }

  public updateCoproducer(_coproducer: CoproducerVM) {
    return this.http.put(`${URL}CoProducerAgreements`, _coproducer);
  }

  public addCoproducer(_coproducer: CoproducerVM) {
    return this.http.post(`${URL}CoProducerAgreements`, _coproducer);
  }

  public importFile(fileUpload: FileUpload) {
    return this.http.post(`${URL}CoProducerAgreements/import`, fileUpload);
  }

  public deactivate(id: number) {
    return this.http.post(`${URL}CoProducerAgreements/deactivate/${id}`, null);
  }

  public activate(id: number) {
    return this.http.post(`${URL}CoProducerAgreements/activate/${id}`, null);
  }

  public getAllSimpleCoProducerAgreementList(): Observable<NameId[]> {
    return this.http.get<NameId[]>(
      `${URL}/CoProducerAgreements/coProducerList`
    );
  }

  public getAllSimpleAdvisorList(): Observable<NameId[]> {
    return this.http.get<NameId[]>(`${URL}/CoProducerAgreements/advisorList`);
  }
}
